import LandingPage from '../templates/LandingPage';
import searchIcon from '../../assets/svg/search.svg'
import Faq from '../components/card/Faq';
import { useState } from 'react';

function FAQ() {

  // const [searchMode, setSearchMode] = useState(false)
  // const [search, setSearch] = useState("")
  const faqs = JSON.parse(JSON.parse(window.localStorage.getItem("bMerchant"))?.widget_faq_data || "[]") || []
  
  return (
    <LandingPage>
      <div className="px-4 lg:px-16 py-18 flex flex-col items-center h-screen section-one">
        <div className="flex w-full lg:w-2/3 mt-32 justify-between mb-4">
          <p className="text-yellow text-2xl lg:text-4xl font-bold text-center lg:text-left w-full">
            Frequently asked <br/>questions?
          </p>
          {/* <div className={`flex opacity-50 text-white items-start ${searchMode ? "border-b-2" : ""} `}>
            <img src={searchIcon} alt="o" className="self-start mt-2 cursor-pointer" width="30px" onClick={ () => setSearchMode(true)} />
            <div className={`mt-3 flex items-center ml-4 ${searchMode ? "" : "hidden"}`}>
              <input type="text" className="bg-transparent focus:outline-none" focus value={search} onChange={ e => setSearch( e.target.value )}/>
              <div className="text-white bg-brown ml-3 bg-opacity-25 w-6 h-6 rounded-full cursor-pointer flex justify-center items-center" onClick={ () => { setSearch(""); setSearchMode(false) }}>&times;</div>
            </div>
            <span className={`text-xl lg:text-3xl place-self-start ml-4 cursor-pointer ${searchMode ? "hidden" : ""}`} onClick={ () => setSearchMode(true)}>Search</span>
          </div> */}
        </div>
        <div className="flex flex-col w-full lg:w-2/3 overflow-y-scroll mb-12">
          {
            faqs.map( (faq, i) => <Faq key={i} title={faq.question} body={faq.answer}></Faq>)
          }
        </div>
      </div>
    </LandingPage>
  );
}

export default FAQ;
